import { render, staticRenderFns } from "./ChartTotalReclamacaoPorCompetencia.vue?vue&type=template&id=6668fd8e&"
import script from "./ChartTotalReclamacaoPorCompetencia.vue?vue&type=script&lang=js&"
export * from "./ChartTotalReclamacaoPorCompetencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports